import { stringify } from "qs";
import fetchClient from "api/client";
import getPerPageQueryParam from "helpers/getPerPageQueryParam";

/**
 * @description GET api/parent-categories/list
 * */
export default function getParentCategoriesList({
  queryKey: [, { page, perPage, ...queryParams }],
  signal,
}) {
  const queryString = stringify(
    {
      ...queryParams,
      page: page || 0,
      ...getPerPageQueryParam(perPage),
    },
    { addQueryPrefix: true },
  );

  return fetchClient.get(`parent-categories/list${queryString}`, { signal });
}
